<template>
    <!-- Główny kontener, zawierający sekcję filtrów i wyniki -->
    <div class="content">
      <div class="d-flex justify-content-between actions-down">
        <label class="location-view-toggle" for="calibration-deviation-location-view-toggle" v-if="step === 1">
          <span class="toggle-label">{{ t('map').toUpperCase() }}</span>
          <input id="calibration-deviation-location-view-toggle" type="checkbox" v-model="useMapLocationList" />
          <span class="toggle-slider"></span>
        </label>
      </div>
      <div class="d-flex filters">
             <!-- Krok 1: komponent filtrów wyświetlany, gdy step === 1 -->
      <FilterCalibrationComponent
        v-if="step === 1"
        :from="'calibration-deviation'"
        :use-map-location-list="useMapLocationList"
      />
      <!-- Krok 2: wyniki wyświetlane, gdy step !== 1 -->
      <div v-else class="results">
        <!-- Jeżeli mamy jakieś wyniki -->
        <div v-if="results && results.length">
          <!-- Iteracja po każdej lokalizacji w wynikach -->
          <div
            v-for="(locBlock) in results"
            :key="locBlock.location.id"
            class="location-block"
          >
            <!-- Nazwa lokalizacji -->
            <h3>{{ locBlock.location.shortName }}</h3>

            <!-- Iteracja po każdym pasie w danej lokalizacji -->
            <div
              v-for="(laneBlock) in locBlock.lanes"
              :key="laneBlock.lane.id"
              class="lane-block"
            >
              <!-- Numer pasa -->
              <!-- <h4>Pas {{ laneBlock.lane.laneNumber }}</h4> -->

              <!-- TU wykres dla tego pasa -->
              <div class="calibration-graph" v-if="laneBlock.graphBase64">
                <img
                  :src="`data:image/png;base64,${laneBlock.graphBase64}`"
                  alt="Wykres kalibracji pasa"
                  style="max-width:100%; margin-bottom:1rem;"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Komunikat, gdy brak wyników -->
        <p v-else>Brak wyników</p>
      </div>
      </div>
    </div>

    <!-- Sekcja przycisków nawigacyjnych: Cofnij / Zastosuj -->
    <div class="d-flex justify-content-between actions">
      <!-- Przycisk "Cofnij" widoczny, gdy step !== 1 -->
      <button
        class="btn-prev"
        v-if="step !== 1"
        @click="back()"
      >
        {{ t('back2').toUpperCase() }}
      </button>
      <!-- Przycisk "Zastosuj" widoczny, gdy step === 1 -->
      <button
        class="btn-next ms-auto"
        v-if="step === 1"
        @click="apply()"
      >
        {{ t('apply').toUpperCase() }}
      </button>
    </div>
</template>
  
  <script>
  import moment from "moment";                           // biblioteka do formatowania daty
  import FilterCalibrationComponent from "./FilterCalibrationComponent";  // komponent filtrów
  import CalibrationsService from "@/services/CalibrationsService";      // serwis pobierający dane
  
  // Ustawienie polskiej lokalizacji dla moment.js
  moment.locale("pl");
  
  export default {
    name: "CalibrationComponent",  // nazwa komponentu
    components: { FilterCalibrationComponent },
    data() {
      return {
        step: 1,       // aktualny krok: 1 = filtr, 2 = wyniki
        results: null, // tu trzymamy dane pobrane z serwisu
        useMapLocationList: false,
      };
    },
    methods: {
      /**
       * Wywoływane po kliknięciu "Zastosuj" w kroku 1.
       * Pobiera dane i przechodzi do kroku 2.
       */
      apply() {
        CalibrationsService.getCalibrationsDeviation()
          .then((response) => {
            this.results = response; // zapis odpowiedzi
            this.step = 2;           // przejście do kroku 2
          })
          .catch((error) => {
            console.error("Error fetching calibrations:", error);
          });
      },
      /**
       * Wywoływane po kliknięciu "Cofnij" w kroku 2.
       * Czyści wyniki i wraca do kroku 1.
       */
      back() {
        this.step = 1;
        this.results = null;
      },
      /**
       * Formatowanie daty na format 'DD.MM.YYYY HH:mm'.
       */
      formatDate(dt) {
        return moment(dt).format("DD.MM.YYYY HH:mm");
      },
      /**
       * Alias do tłumaczeń (vue-i18n): zwraca przetłumaczony tekst.
       */
      t(key) {
        return this.$t(key);
      },
    },
  };
  </script>
  
  <style scoped>
  /* Styl głównego kontenera */
  .content {
    width: 100%;
    min-height: 270px;
    margin-bottom: 20px;
  }
  /* Granice sekcji filtrów */
  .filters {
    border-top: 1px solid #bbbbbb;
    border-bottom: 1px solid #bbbbbb;
  }
  /* Styl sekcji wyników */
  .results {
    width: 100%;
    padding: 1rem;
    background: #f9f9f9;
    border-radius: 4px;
    font-family: monospace;
    font-size: 0.9rem;
  }
  
  /* Kontener przycisków nawigacyjnych */
  .actions {
    background-color: white;
    min-height: 43px;
  }
  /* Wspólny styl przycisków */
  .actions button {
    border: 0;
    font-size: 19px;
    font-weight: bold;
    background: none;
  }

  .actions-down {
    background-color: white;
    min-height: 45px;
  }

  .location-view-toggle {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    margin-left: 20px;
  }

  .toggle-label {
    font-size: 12px;
    font-weight: 700;
    color: #58585a;
    letter-spacing: 0.04em;
  }

  .location-view-toggle input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .toggle-slider {
    position: relative;
    width: 44px;
    height: 24px;
    border-radius: 999px;
    background-color: #cfd4da;
    transition: background-color 0.2s ease;
  }

  .toggle-slider::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
    transition: transform 0.2s ease;
  }

  .location-view-toggle input:checked + .toggle-slider {
    background-color: #35c759;
  }

  .location-view-toggle input:checked + .toggle-slider::before {
    transform: translateX(20px);
  }
  /* Styl przycisku Zastosuj, z ikonką po prawej */
  .actions .btn-next {
    position: relative;
    padding: 8px 40px 8px 8px;
    color: #58585a;
  }
  .actions .btn-next::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    width: 30px;
    height: 20px;
    background: url("../assets/icons/dalej.png") no-repeat center;
  }
  .actions .btn-next:hover::after {
    background-image: url("../assets/icons/dalej_over.png");
  }
  /* Styl przycisku Cofnij */
  .actions .btn-prev {
    margin-left: 30px;
    padding: 0 0 0 40px;
    position: relative;
    color: #58585a;
  }
  .actions .btn-prev:before {
    content: "";
    position: absolute;
    left: 0;
    top: 11px;
    width: 30px;
    height: 20px;
    background: url("../assets/icons/powrot.png") no-repeat left top;
  }
  .actions .btn-prev:hover:before {
    background: url("../assets/icons/powrot_over.png") no-repeat left top;
  }
  /* Podświetlenie wiersza, gdy dewiacja > 7 */
  .red td {
    background-color: #f8d7da !important;
  }
  </style>
